import { t as AitisalSdk } from "../../aitisal-sdk-B2mK3RTK.mjs";

//#region restaurant/order/order.ts
async function createOrder(restaurantUUID, salesChannelUUID, createOrder) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/${salesChannelUUID}/orders`, createOrder);
}
/**
* @public
*/
async function createGuestOrder(restaurantUUID, salesChannelUUID, createOrder) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/${salesChannelUUID}/orders/guest`, createOrder);
}
/**
* @public
*/
async function createPrePaidGuestOrder(restaurantUUID, salesChannelUUID, createOrder) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/${salesChannelUUID}/orders/guest/prepaid`, createOrder);
}
async function getOrder(restaurantUUID, orderUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/${orderUUID}/any`);
}
async function updateOrderLocation(restaurantUUID, orderUUID, location) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/orders/${orderUUID}/location`, location);
}
async function getActiveOrder(restaurantUUID, orderUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/${orderUUID}/active`);
}
async function getActiveOrders(restaurantUUID, salesChannelType, orderUUIDs) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/active`, { params: {
		salesChannelType,
		orderIds: orderUUIDs.join(",")
	} });
}
async function browseNewOrders(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/new`, { params });
}
async function browseAcceptedOrders(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/accepted`, { params });
}
async function browseArchivedOrders(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/orders/archived`, { params });
}
async function browseUserOrders(userUUID, restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/orders/user/${userUUID}`, { params: { restaurantId: restaurantUUID } });
}
async function acceptOrder(restaurantUUID, orderUUID) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/accept`);
}
async function closeOrder(restaurantUUID, orderUUID) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/close`);
}
async function cancelOrder(restaurantUUID, orderUUID, cancelOrder) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/cancel`, cancelOrder || {});
}
async function transferOrder(restaurantUUID, orderUUID, transferOrder) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/transfer`, transferOrder);
}
async function updateOrder(restaurantUUID, orderUUID, updateOrder) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/orders/${orderUUID}`, updateOrder);
}
async function deleteOrderItem(restaurantUUID, orderUUID, orderItemUUID) {
	return AitisalSdk.getInstance().delete(`restaurants/${restaurantUUID}/orders/${orderUUID}/order-items/${orderItemUUID}`);
}
async function applyDiscount(restaurantUUID, orderUUID, applyDiscount) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/orders/${orderUUID}/discount`, applyDiscount);
}
async function removeDiscount(restaurantUUID, orderUUID) {
	return AitisalSdk.getInstance().delete(`restaurants/${restaurantUUID}/orders/${orderUUID}/discount`);
}
async function changePaymentMethod(restaurantUUID, orderUUID, paymentMethod) {
	return AitisalSdk.getInstance().patch(`restaurants/${restaurantUUID}/orders/${orderUUID}/payment-method`, paymentMethod);
}

//#endregion
//#region restaurant/order/sales-session.ts
async function openSalesSession(restaurantUUID, openSalesSession) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/sales-sessions/open`, openSalesSession);
}
async function getActiveSalesSession(restaurantUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/active`);
}
async function getSalesSession(restaurantUUID, salesSessionUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/${salesSessionUUID}`);
}
async function getSalesSessionSummary(restaurantUUID, salesSessionUUID) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/${salesSessionUUID}/summary`);
}
async function browseSalesSessionOrders(restaurantUUID, salesSessionUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/${salesSessionUUID}/orders`, { params });
}
async function closeSalesSession(restaurantUUID, salesSessionUUID, closeSalesSession) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/sales-sessions/${salesSessionUUID}/close`, closeSalesSession);
}
async function createSalesSessionTransaction(restaurantUUID, salesSessionUUID, createSalesSessionTransaction) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/sales-sessions/${salesSessionUUID}/transactions`, createSalesSessionTransaction);
}
async function browseSalesSessions(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions`, { params });
}
async function getSalesPersonPerformance(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/reports/sales-person-performance`, { params });
}
async function getCashDiscrepancyReport(restaurantUUID, params) {
	return AitisalSdk.getInstance().get(`restaurants/${restaurantUUID}/sales-sessions/reports/cash-discrepancy`, { params });
}

//#endregion
//#region restaurant/order/suborder.ts
async function createSubOrder(restaurantUUID, orderUUID, createSubOrder) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/orders/${orderUUID}/suborders`, createSubOrder);
}
async function createGuestSubOrder(restaurantUUID, orderUUID, createSubOrder) {
	return AitisalSdk.getInstance().post(`restaurants/${restaurantUUID}/orders/${orderUUID}/suborders/guest`, createSubOrder);
}
async function acceptSubOrder(restaurantUUID, orderUUID, subOrderUUID) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/suborders/${subOrderUUID}/accept`);
}
async function cancelSubOrder(restaurantUUID, orderUUID, subOrderUUID) {
	return AitisalSdk.getInstance().put(`restaurants/${restaurantUUID}/orders/${orderUUID}/suborders/${subOrderUUID}/cancel`);
}

//#endregion
export { acceptOrder, acceptSubOrder, applyDiscount, browseAcceptedOrders, browseArchivedOrders, browseNewOrders, browseSalesSessionOrders, browseSalesSessions, browseUserOrders, cancelOrder, cancelSubOrder, changePaymentMethod, closeOrder, closeSalesSession, createGuestOrder, createGuestSubOrder, createOrder, createPrePaidGuestOrder, createSalesSessionTransaction, createSubOrder, deleteOrderItem, getActiveOrder, getActiveOrders, getActiveSalesSession, getCashDiscrepancyReport, getOrder, getSalesPersonPerformance, getSalesSession, getSalesSessionSummary, openSalesSession, removeDiscount, transferOrder, updateOrder, updateOrderLocation };
//# sourceMappingURL=index.mjs.map